const utils = require('frontend-controller/lib/utils')

module.exports = {
	config: {
		entityContext: 'address',		// entityContext (address, trip, activity)
		scope: 'art_crm',
		privilegeBase: 'artcrm_addresses',
		entityPropertiesFormComponentClass: 'templates_artCrm_entity_propertiesForm',
		showTripNavButton: false,
		showCooperationNavButton: false,
		showDetailsNavButton: false,
		showRefreshNavButton: false,
		entityIsDeletable: false,
		preventDeletions: false
	},

	model: {
		parentEntityID: false,
		parentEntity: {}, // stores the entity from the parents (whatever has opened this record) point of view
	},

	events: {
		action: {
			type: 'click',
			selector: 'section.top button',
			action: function(event){
				event.preventDefault();
				event.stopImmediatePropagation();

				var self = event.data.component;
				var $target = $(event.target);
				if($target.length > 0){
					var fieldType = $target.data('fieldType');
					if(fieldType === 'submit'){
						self.submit();
					}
					else if(fieldType === 'cancel'){
						self.cancel();
					}
					else if(fieldType === 'delete'){
						self.delete();
					}
					else if(fieldType === 'refresh'){
						self.refreshRecord();
					}
					else if(fieldType === 'showEdit'){
						self.showEdit(
							$target.data('buttonMode'),
							((self.model.entityPropertiesForm.resourceData.data || {}).attributes || {}).addressType || '',
							self.model.parentEntityID,
							(self.model.entityPropertiesForm.resourceData.data || {}).attributes || {}
						);
					}
				}
			}
		}
	},

	methods: {
		dataDealer: function(){
			if(!this.config.preventDeletions){
				storage = (storage || (window || {}).storage);
				if(storage){
					this.config.entityIsDeletable = Boolean(storage.user.hasAccessTo(this.config.privilegeBase + ':delete', this.config.scope));
				}
			}
			if(!this.model.parentEntityID){
				this.model.parentEntity = this.getResourceRegisterContent('entity') || {};
				this.model.parentEntityID = this.model.parentEntity.resourceID;
			}
		},

		submit: function(){
			var self = this;
			self.model.entityPropertiesForm.submit().then(function(context){
				self.callHandler('recordControllerResourcesModified');
			});
		},

		cancel: function(){
			this.removeTab();
		},

		removeTab: function(){
			var self = this;
			if(self.model.tabStrip && self.model.tabRegisterSecret){
				self.model.tabStrip.removeTab(self.model.tabRegisterSecret);
			}
		},

		delete: function(){
			var self = this;
			if(this.model.parentEntityID && this.config.entityIsDeletable){
				return self.performDecision(
					'confirm',
					{
						component:  self,
						title:      storage.__(`hint.delete.really.${self.config.entityContext}.title`),
						message:    storage.__(`hint.delete.really.${self.config.entityContext}.message`)
					}
				).then(function(context) {
					if (context.decision.type === 'yes') {
						return self.performAction(self.prepareAction(`delete_${self.config.entityContext}`, self.model.parentEntityID)).then(function(){
							self.removeTab();
							self.callHandler('recordControllerResourcesModified');
							return utils.promise.resolve();
						});
					}

					return utils.promise.reject();
				});
			}
		},

		refreshRecord: function(){
			var self = this;
			if(!self.model.parentEntityID) {
				return self.performAction(
					self.prepareAction('message', undefined, {
						messageDisplay: {
							message: 'error:refresh.artcrm_addresses.missingPrimaryKey'
						}
					})
				);
			}

			self.backupScrollPosition();
			if(self.model.entityPropertiesForm){
				self.model.entityPropertiesForm.model.dirtyFields = {};
				self.model.entityPropertiesForm.find('templates_artCrm_connectionsTable_connectionsTable', function(connectionsTable){
					connectionsTable.keepFirstPage();
					if(typeof connectionsTable.resetData === 'function'){
						connectionsTable.resetData();
					}
				});
			}
			return self.refresh(true, { restoreScrollPositionByRefresh: true });
		},

		backupScrollPosition: function(){
			this.model.scrollTop = this.$.find('section.main').scrollTop();
		},

		restoreScrollPosition: function(){
			if(this.model.scrollTop){
				this.$.find('section.main').scrollTop(this.model.scrollTop);
				this.model.scrollTop = 0;
			}
		},

		showEdit: function(buttonMode){},

		handleError: function(context){
			var self = this;
			var apiError = utils.extractBaseError(context.error) || {};

			if((context.action || {}).originalActionKey === 'delete_address' && apiError.statusCode == 409 && apiError.errorCode === 'SEQUELIZE_FOREIGN_KEY_NOT_EXISTS_ERROR'){
				return self.performAction(
					self.prepareAction('message', undefined, {
						messageDisplay: {
							message: `error:delete.artcrm_addresses.foreignKey.${apiError.table || 'default'}`
						}
					})
				);
			}
			context.errorUnhandled = true;
			return utils.promise.resolve(context);
		}
	},

	hooks: {
		attach: function($element, options){
			var self = this;
			if(!self.model.entityPropertiesForm){
				self.find(self.config.entityPropertiesFormComponentClass, function(propertiesForm){
					self.model.entityPropertiesForm = propertiesForm;
				});
			}

			if(!self.model.tabStrip){
				self.closest('base_tabStrip_tabContent', function(tabContent){
					self.model.tabRegisterSecret = (tabContent.config || {}).registerSecret;
					tabContent.closest('base_tabStrip_tabStrip', function(tabStrip){
						self.model.tabStrip = tabStrip;
					});
				});
			}

			if(options.restoreScrollPositionByRefresh){
				self.restoreScrollPosition();
			}
		}
	}
}